var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 88 86.7",
    style: {
      enableBackground: "new 0 0 88 86.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#828385;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M44.6,5.3c-0.6,0-1.3,0-1.9,0c-0.4,0-0.8,0-1.2,0c-0.2,0-0.5,0-0.7,0C20.5,6.3,4.4,23.1,4.4,43.6 c0,21.2,17.2,38.3,38.3,38.3C63.9,81.9,81,64.7,81,43.6C81,23.1,64.9,6.3,44.6,5.3z M27.5,45.7c0,0.6-0.1,1.1-0.2,1.7l21.6,10.9 c0.5-0.6,1.1-1.1,1.8-1.5c3.1-1.8,7.1-0.7,8.9,2.4c1.8,3.1,0.7,7.1-2.4,8.9c-3.1,1.8-7.1,0.7-8.9-2.4c-0.9-1.5-1.1-3.3-0.7-4.8 L26,49.8c-1.2,1.4-3,2.3-5,2.3c-3.6,0-6.5-2.9-6.5-6.5s2.9-6.5,6.5-6.5c1.8,0,3.3,0.7,4.5,1.8l22.2-14.6c-0.2-0.7-0.3-1.3-0.3-2.1 c0-3.6,2.9-6.5,6.5-6.5s6.5,2.9,6.5,6.5s-2.9,6.5-6.5,6.5c-1.8,0-3.5-0.8-4.7-2L27.1,43.4C27.4,44.1,27.5,44.8,27.5,45.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/shareIcon.4d1621dd0a701c5638eb367b7522ec2d.svg";
export { ForwardRef as ReactComponent };